export default "__VITE_ASSET__2291fe38__"